import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import createReactClass from 'create-react-class';
import { IconButton } from '@mui/material';
import { withTranslation } from 'react-i18next';

import h from '@utils/helpers';
import Misc from '../Misc';
import { Button, TextInput, Modal, Icon } from '@ts/storybook';

const RelatedModel = createReactClass({
  displayName: '930-RelatedModel',
  propTypes: {
    app: PropTypes.object,
    data: PropTypes.object,
    fMultiple: PropTypes.bool,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    fnChange: PropTypes.func,
    fShowIdField: PropTypes.bool,
    fShowLabelField: PropTypes.bool,
    possibleModels: PropTypes.object,
    SearchComponent: PropTypes.func,
    searchComponentProps: PropTypes.object,
    fnSearchLabel: PropTypes.func,
    idLabel: PropTypes.string,
    label: PropTypes.string,
    fnDescription: PropTypes.func.isRequired,
    fDisabled: PropTypes.bool,
    fRequired: PropTypes.bool,
    fReturnAttribute: PropTypes.string,
    fReturnModel: PropTypes.bool,
  },

  getDefaultProps() {
    return {
      fMultiple: false,
      fShowIdField: true,
      fShowLabelField: true,
      searchComponentProps: {},
      fDisabled: false,
      idLabel: 'ID',
      fRequired: false,
      fReturnAttribute: 'id',
    };
  },

  getInitialState() {
    const state = {
      fSearchMenuShown: false,
      fModalShown: false,
    };
    if (!this.props.fMultiple) {
      state.displayId = h.getDisplayId(this._relatedModel()) || this.props.value;
    }
    return state;
  },

  focus() {
    return this.refs.input != null ? this.refs.input.focus() : undefined;
  },

  render() {
    this._fMultiple = this.props.fMultiple;
    this._hasIdField = this.props.fShowIdField && !this.props.fMultiple;
    return (
      <div style={this.props.style}>
        <Misc.FlexRow wrap={false}>
          {this._hasIdField ? this._renderDisplayId() : undefined}
          {this._hasIdField ? <Misc.FlexRowSpacer width={10} /> : undefined}
          {this._renderLabelField()}
          <Misc.FlexRowItem style={{ width: 50 }}>{this._renderSearchButton()}</Misc.FlexRowItem>
        </Misc.FlexRow>
        {this._renderSearchDialog()}
      </div>
    );
  },

  _renderDisplayId() {
    if (!this._hasIdField) {
      return;
    }
    return (
      <Misc.FlexRowItem width={150}>
        <TextInput
          label={this.props.idLabel}
          value={this.state.displayId != null ? this.state.displayId.toString() : undefined}
          onChangeValue={this._handleChangeDisplayIdValue}
          disabled={this.props.fDisabled}
          required={this.props.fRequired}
        />
      </Misc.FlexRowItem>
    );
  },

  _renderLabelField() {
    let description;
    let errorText;
    if (!this.props.fShowLabelField) {
      return;
    }
    const relatedModel = this._relatedModel();
    if (relatedModel) {
      description = this.props.fnDescription(relatedModel);
    } else if (this.props.description) {
      ({ description } = this.props);
    } else {
      description = '';
    }

    if (this.props.fRequired && !description) {
      errorText = 'Required';
    } else {
      errorText = undefined;
    }
    return (
      <Misc.FlexRowFlexItem minWidth={80}>
        <TextInput disabled label={this.props.label} value={description} required={this.props.fRequired} errorText={errorText} />
      </Misc.FlexRowFlexItem>
    );
  },

  _renderSearchButton() {
    if (!this.props.SearchComponent && !this.props.fnSearchLabel) {
      return;
    }
    if (this.props.SearchComponent) {
      return (
        <IconButton disabled={this.props.fDisabled} onClick={this._handleSearchShow} style={this._styleSearchButton()}>
          <Icon icon="action-search" />
        </IconButton>
      );
    }
    return this._renderSearchMenu();
  },

  _renderSearchDialog() {
    if (!this.props.SearchComponent) {
      return;
    }

    const { SearchComponent } = this.props;

    return (
      <Modal
        withHeader
        title={this.props.t('Please click on an item to select it')}
        labelCancel="Cancel"
        labelOk="Clear"
        withCloseIcon={false}
        fullWidth
        maxWidth="md"
        onSubmit={this._handleSearchDialogClear}
        onClose={() => this.setState({ fModalShown: false })}
        open={this.state.fModalShown}
      //autoDetectWindowHeight
      //autoScrollBodyContent
      //contentStyle={{ maxWidth: 'none' }}
      >
        <div style={{ height: 500 }}>
          <SearchComponent
            {...Object.assign(
              {
                app: this.props.app,
                data: this.props.data,
                fnChange: this._handleSearchDialogChange,
                fPortal: true,
              },
              this.props.searchComponentProps
            )}
          />
        </div>
      </Modal>
    );
  },

  _renderSearchMenu() {
    let value;
    if (!this.props.fnSearchLabel) {
      return;
    }
    if (this.props.fMultiple) {
      value = _.map(this.props.value, value => `${value}`);
    } else {
      value = `${this.props.value}`;
    }
    const iconElement = <Icon icon="action-search" disabled={this.props.fDisabled} />;
    const menuItems = this.props.possibleModels.map(model => {
      const id = model.get('id');
      const label = this.props.fnSearchLabel(model);
      return <MenuItem key={id} value={`${id}`} primaryText={label} />;
    });

    return (
      <div style={{ position: 'relative' }}>
        <IconMenu
          disabled={this.props.fDisabled}
          iconButtonElement={iconElement}
          value={value}
          multiple={this.props.fMultiple}
          onChange={this._handleSearchMenuChange}
          desktop
          style={this._styleSearchMenu()}
        >
          {menuItems}
        </IconMenu>
        <div style={this._styleOverlayToAvoidClicks()} />
      </div>
    );
  },

  _relatedModel() {
    let out;
    if (!this.props.value) {
      return null;
    }
    if (this.props.fMultiple) {
      out = _.map(this.props.value, id => h.getCollectionModel(this.props.possibleModels, id, this.props.fReturnAttribute));
    } else if (this.props.possibleModels) {
      out = h.getCollectionModel(this.props.possibleModels, this.props.value, this.props.fReturnAttribute);
    } else {
      out = this.state != null ? this.state.selectedModel : undefined;
    }
    return out;
  },

  _handleChangeDisplayIdValue(value) {
    // Update own state
    const displayId = value;
    this.setState({ displayId });
    // Look for new associated model and report back up
    let model = null;
    if (!_.isEmpty(displayId && this.props.possibleModels != null)) {
      model = this.props.possibleModels.find(
        o => o.get('logicalId') === displayId || (!o.get('logicalId') && o.get('id') === displayId)
      );
      if (model === undefined) {
        model = null;
      }
    }
    if (model != null) {
      if (this.props.fReturnAttribute) {
        let left;
        return typeof this.props.fnChange === 'function'
          ? this.props.fnChange((left = model != null ? model.get(this.props.fReturnAttribute) : undefined) != null ? left : null)
          : undefined;
      }
      let left1;
      return typeof this.props.fnChange === 'function'
        ? this.props.fnChange((left1 = model != null ? model.get('id') : undefined) != null ? left1 : null)
        : undefined;
    }
    return typeof this.props.fnChange === 'function' ? this.props.fnChange(displayId) : undefined;
  },

  _handleSearchShow() {
    if (this.props.SearchComponent) {
      return this.setState({ fModalShown: true });
    } else if (this.props.fnSearchLabel) {
      return this.setState({ fSearchMenuShown: !this.state.fSearchMenuShown });
    }
  },
  _handleSearchDialogClear() {
    if (this._hasIdField) {
      this.setState({ displayId: null });
    }
    this.setState({ selectedModel: null });
    if (typeof this.props.fnChange === 'function') {
      this.props.fnChange(null);
    }
    return this.setState({ fModalShown: false });
  },
  _handleSearchDialogChange(model) {
    if (model == null) {
      return this._handleSearchDialogClear();
    }
    this.setState({ selectedModel: model });
    if (this._hasIdField) {
      this.setState({ displayId: `${h.getDisplayId(model)}` });
    }
    if (this.props.fReturnModel) {
      if (typeof this.props.fnChange === 'function') {
        this.props.fnChange(model);
      }
    } else if (this.props.fReturnAttribute) {
      if (typeof this.props.fnChange === 'function') {
        let left;
        this.props.fnChange((left = model != null ? model.get(this.props.fReturnAttribute) : undefined) != null ? left : null);
      }
    } else if (typeof this.props.fnChange === 'function') {
      let left1;
      this.props.fnChange((left1 = model != null ? model.get('id') : undefined) != null ? left1 : null);
    }
    return this.setState({ fModalShown: false });
  },
  _handleSearchMenuChange(ev, menuValue) {
    if (this.props.fDisabled) {
      return;
    }
    if (this.props.fMultiple) {
      return typeof this.props.fnChange === 'function' ? this.props.fnChange(menuValue) : undefined;
    }
    return this.props.fnChange(menuValue);
  },

  _styleSearchButton() {
    return { marginTop: 20 };
  },
  _styleSearchMenu() {
    return {
      marginTop: 20,
      padding: 12,
      cursor: !this.props.fDisabled ? 'pointer' : undefined,
    };
  },
  _styleOverlayToAvoidClicks() {
    return {
      display: this.props.fDisabled ? 'block' : 'none',
      position: 'absolute',
      top: 20,
      right: 0,
      height: 48,
      width: 48,
      backgroundColor: 'red',
      opacity: 0,
    };
  },
});
export default withTranslation()(RelatedModel);
